var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c("session-table", { attrs: { timezone: _vm.timezone } }),
      _vm._v(" "),
      _c("session-sidebar", { attrs: { model: _vm.model } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }